import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '../../../../../services/alert.service';
import { NgxPopupComponent } from '../../../../shared/ngx-popups/ngx-popups/components/popup.component';
import { UserService } from '../../../../../services/user.service';

@Component({
    selector: 'app-share-link',
    templateUrl: './share-link.component.html',
    styleUrls: ['./share-link.component.scss'],
    standalone: false
})
export class ShareLinkComponent implements OnInit {
  @Input() popup: NgxPopupComponent;
  @Input() selectedPeriodType: string;
  @Input() selectedStatementDate: string;
  @Input() selectedStatementDateFrom: string;
  @Input() selectedStatementDateTo: string;
  @Input() multiMonth: string;
  @Input() selectedTypes: Array<any>;
  @Input() portalLink: string;

  bankId: string;
  period: string;

  constructor( private _alertService: AlertService,
               private _userService: UserService) {
  }

  ngOnInit(): void {
    this.bankId = this.capitalizeFirstLetter(this._userService.getBankId());
  }

  capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  copyToClipboard() {
    const portalLink = document.getElementById('portalLink') as HTMLInputElement;
    if (portalLink) {
        portalLink.select();
        document.execCommand('copy');
        this._alertService.success('Copied to clipboard!');
    }
  }

  sendEmail() {
    if (this.multiMonth) {
        this.period = this.selectedStatementDateFrom + ' - ' + this.selectedStatementDateTo;
    } else {
        this.period = this.selectedStatementDate;
    }

    if (this.selectedPeriodType.toLowerCase() === 'semi_annually') {
        this.selectedPeriodType = 'semiannual';
    }

    if (this.selectedPeriodType.toLowerCase() === 'annually') {
        this.selectedPeriodType = 'annual';
    }

    const subject = this.bankId + ' ' + this.capitalizeFirstLetter(this.selectedPeriodType.toLowerCase()) + ' reporting due!';

    let body = 'Hi,%0D%0A%0D%0A Your reporting to ' +
    this.bankId +
    ' is due! Please submit the following documents for the period: ' +
    this.period +
    '%0D%0A%0D%0A';

    this.selectedTypes.forEach(type => {
      if (type) {
        body += '- ' + type + '%0D%0A';
      }
    });

    body += '%0D%0APlease use the link below to securely upload the requested documents.%0D%0A%0D%0A'
    + encodeURI(this.portalLink) +
    ' %0D%0A%0D%0AThanks!';

    this.openWindow(subject, body);
  }

  openWindow(subject, body) {
    window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
  }
}
